import React from 'react';
import { apiPost, getHostApi, getHostUrl } from '../../../store/apiWrapper';
import { bindActionCreators } from 'redux';
import { Circles } from '../../common/loadingComponent';
import { connect } from 'react-redux';
import { FileUpload } from '../../common/fileUpload';
import { Formik, Field, Form } from 'formik';
import { getParams } from '../../common/utils';
import { hasPermission } from '../../../store/apiWrapper';
import { isGuid, isNullOrUndefined, isValidLanguage } from '../../../store/storeFunctions';
import { number as YupNumber, object as YupObject, string as YupString } from '../../common/Yup';
import { popupActions } from '../../../store/popupStore';
import { Redirect } from 'react-router';
import { registrySearchActions, REGISTRY, SEARCH_TYPE } from '../../../store/ceeSearchStore';
import { relationsSearchActions, searchInstances } from '../../../store/relationsSearchStore';
import RelationsSearchInstance from "../relations/relationsSearchInstance";

import { windowActions } from '../../../store/windowStore';
import { withLocalize, Translate } from 'react-localize-redux';
import { withRouter } from 'react-router';
import BbCheckbox from '../../styling/bbFormikCheckbox';
import BbDatePicker from '../../common/datePicker';
import BbInput from '../../styling/bbInput';
import CeeErrorMessage from './ceeErrorMessage';
import classnames from 'classnames'
import CountryField from './countryField';
import FormButtonsRow from './formButtonsRow';
import FormMenuControl from '../../common/formMenuControl'
import Message from '../../common/message';
import moment from 'moment';
import SearchTip from '../../common/searchTip';
import TabLink from '../tabLink';
import UnderlinedTitle from '../../common/underlinedTitle';

import IconFO from '../../../img/icons/BBiconsFo';
import IconFPO from '../../../img/icons/BBiconsFop';
import IconPO from '../../../img/icons/BBiconsPo';
import IconPOCZSK from '../../../img/icons/BBiconsCzSkPo';
import IconBulk from '../../../img/icons/BBiconsHromadnyDotaz';
import IconCause from '../../../img/icons/BBiconsSpisovaZnacka';

const CAUSE_AMOUNT_MIN = 0;
const CAUSE_AMOUNT_MAX = 9999999999;
const CAUSES_MIN = 1;
const CAUSES_MAX = 100;
const CAUSES_MAX_TOTAL = 100000;
const YEAR_MIN = 0;
const ESS_MIN = 0;
const ESS_MAX = 100;

class CeeSubjectSearchComponent extends React.Component {
    state = {
        mounted: false,
        selected: SEARCH_TYPE.fo,
        countries: [],
        prefilledData: null,
    };

    buttonPressed = "";

    setPrefilledData() {
        if (this.props.registry === REGISTRY.aml) {
            this.props.getPrefilledData(this.props.registry, {});
        }

        const query = getParams(window.location.search);
        if (Object.keys(query).length === 0)
            return null;

        let data = {}
        data.type = SEARCH_TYPE.fo;

        if (query.city)
            data.city = query.city;
        if (query.birthDate)
            data.dob = query.birthDate;
        if (query.surname) {
            data.additionalData = {};
            data.additionalData.surname = query.surname;
            if (query.name)
                data.additionalData.name = query.name;
        } else if (query.name) {
            data.name = query.name;
        }
        if (query.companyId) {
            data.ico = query.companyId;
            data.type = SEARCH_TYPE.po;
        }
        if (query.companyName) {
            data.businessName = query.companyName;
            data.type = SEARCH_TYPE.fpo;
        }
        if (query.birthYear) {
            data.birthYear = parseInt(query.birthYear);
        }
        if (query.entrepreneurId) {
            this.props.getPrefilledData(this.props.registry, { entityId: query.entrepreneurId });
        }

        this.setState({ selected: data.type, prefilledData: data });
    }

    createValidationSchema = (registry) => {
        const wrongInputMsg = this.props.translate("Search.Common.Validation.WrongInput");
        const wrongCombinationMsg = this.props.translate("Error.WrongInputCombination");
        const wrongIcoLength = this.props.translate("Search.Cee.ValidationError.CompanyId");
        const wrongPinLength = this.props.translate("Search.Cee.ValidationError.Pin");
        const wrongMaxCauses = this.props.translate("Search.Cee.ValidationError.MaxCauses");

        if (registry === REGISTRY.aml) {
            return this.createAMLValidationSchema();
        }

        return YupObject().shape({
            maxCauses: YupNumber().notRequired()
                .when('includeMonetary', {
                    is: (val) => val == true,
                    then: fieldSchema => fieldSchema.required(wrongInputMsg),
                })
                .test('monetary', wrongMaxCauses, function (item) {
                    return isNullOrUndefined(item) || this.parent.includeMonetary === false || isNullOrUndefined(this.parent.maxTotalCauses) ||
                        (!isNullOrUndefined(this.parent.maxTotalCauses) && (item <= this.parent.maxTotalCauses))
                }),
            birthId: YupString().test('searchCriteria', wrongCombinationMsg, function (item) {
                if (registry === REGISTRY.cee) {
                    return isNullOrUndefined(item) || (isNullOrUndefined(this.parent.fullName) &&
                        isNullOrUndefined(this.parent.address) && isNullOrUndefined(this.parent.birthDate))
                }
                else if (this.parent.buttonPressed === REGISTRY.rpve) {
                    return isNullOrUndefined(item) || !(!isNullOrUndefined(this.parent.birthDate) || !isNullOrUndefined(this.parent.city)
                        || isNullOrUndefined(this.parent.firstName) || isNullOrUndefined(this.parent.surname))
                }
                else {
                    return isNullOrUndefined(item) || (isNullOrUndefined(this.parent.firstName) && isNullOrUndefined(this.parent.surname) &&
                        (isNullOrUndefined(this.parent.city) || isNullOrUndefined(this.parent.birthDate)))
                }
            }).test('length', wrongPinLength, (v) => isNullOrUndefined(v) || v === '' || /(^\d{2}(([05][0-9])|([16][0-2]))((0[1-9])|([12]\d)|(3[01]))\d{3}$)|(^\d{2}(([0257][0-9])|([1368][0-2]))((0[1-9])|([12]\d)|(3[01]))\d{4}$)|(^\d{2}(([05][0-9])|([16][0-2]))((0[1-9])|([12]\d)|(3[01]))([\/]{1}?)\d{3}$)|(^\d{2}(([0257][0-9])|([1368][0-2]))((0[1-9])|([12]\d)|(3[01]))([\/]{1}?)\d{4}$)/.test(v.trim())),
            fullName: YupString().test('searchCriteria', wrongCombinationMsg, function (item) {
                return isNullOrUndefined(item) || (isNullOrUndefined(this.parent.birthId) &&
                    (!isNullOrUndefined(this.parent.address) || !isNullOrUndefined(this.parent.birthDate)))
            }),
            birthDate: YupString().test('searchCriteria', wrongCombinationMsg, function (item) {
                if (this.parent.buttonPressed === REGISTRY.rpve) {
                    return isNullOrUndefined(item) || !(!isNullOrUndefined(this.parent.birthId) || !isNullOrUndefined(this.parent.city)
                        || isNullOrUndefined(this.parent.firstName) || isNullOrUndefined(this.parent.surname))
                }
                else {
                    return isNullOrUndefined(item) || (isNullOrUndefined(this.parent.address)
                        && isNullOrUndefined(this.parent.birthId) && (!isNullOrUndefined(this.parent.fullName) || !isNullOrUndefined(this.parent.surname)))
                }
            }),
            city: YupString().test('searchCriteria', wrongCombinationMsg, function (item) {
                if (this.parent.buttonPressed === REGISTRY.rpve) {
                    return isNullOrUndefined(item)
                }
                else return true;
            }),
            address: YupString().test('searchCriteria', 'address', function (item) {
                return isNullOrUndefined(item) || (isNullOrUndefined(this.parent.birthDate)
                    && isNullOrUndefined(this.parent.birthId) && !isNullOrUndefined(this.parent.fullName))
            }),
            companyName: YupString().test('searchCriteria', wrongCombinationMsg, function (item) {
                return isNullOrUndefined(item) ||
                    (isNullOrUndefined(this.parent.poIco))
            }).min(5, wrongInputMsg),
            poIco: YupString().test('searchCriteria', wrongCombinationMsg, function (item) { return isNullOrUndefined(item) || (isNullOrUndefined(this.parent.companyName)) })
                .test('length', wrongIcoLength, (v) => isNullOrUndefined(v) || v === '' || v.replace(/\s/g, '').length === 8),
            surname: YupString().test('searchCriteria', wrongCombinationMsg, function (item) {
                if (this.parent.buttonPressed === REGISTRY.rpve) {
                    return true;
                }
                else {
                    return isNullOrUndefined(item) || (isNullOrUndefined(this.parent.birthId) &&
                        (!isNullOrUndefined(this.parent.city) || !isNullOrUndefined(this.parent.birthDate)))
                }
            })
        });
    }

    createAMLValidationSchema = () => {
        const wrongInputMsg = this.props.translate("Search.Common.Validation.WrongInput");

        var minAmlDate = moment('1901-01-01');
        var maxAmlDate = moment('2099-12-31');
        const wrongAmlDateMsg = this.props.translate("Search.Common.Validation.WrongAmlDate").replace('{min}', minAmlDate.format("l")).replace('{max}', maxAmlDate.format("l"));
        const wrongAmlYearMsg = this.props.translate("Search.Common.Validation.WrongAmlYear");

        switch (this.state.selected) {
            case SEARCH_TYPE.fo:
                return YupObject().shape({
                    firstName: YupString().trim().required(wrongInputMsg),
                    surname: YupString().trim().required(wrongInputMsg),
                    birthDate: YupString().test('amlDateCheck', wrongAmlDateMsg, function (item) {
                        if (!isNullOrUndefined(item) || item !== '') {
                            if (moment(item, "DD.MM.YYYY", true).isValid()) {
                                let currentDate = moment(item,  "DD.MM.YYYY", true).format("YYYY-MM-DD");
                                minAmlDate = moment(minAmlDate).format("YYYY-MM-DD");
                                maxAmlDate = moment(maxAmlDate).format("YYYY-MM-DD");
                                let result = moment(currentDate).isBetween(minAmlDate, maxAmlDate)
                                return result;
                            } else {
                                return moment(item).isBetween(minAmlDate, maxAmlDate);
                            } 

                        }
                    }),
                    birthYear: YupNumber().nullable().test('amlBirthYearCheck',
                        wrongAmlYearMsg,
                        (value) => isNullOrUndefined(value) || (value >= 1901 && value <= 2099)
                    )
                });
            case SEARCH_TYPE.fpo:
                return YupObject().shape({
                    businessName: YupString().trim().required(wrongInputMsg)
                });
            case SEARCH_TYPE.po:
                return YupObject().shape({
                    poIco: YupString().trim().required(wrongInputMsg),
                    poCountry: YupString().required(wrongInputMsg)
                });
            default:
                return null;
        }
    }

    render() {
        if (!this.props[this.props.registry].isFormRendered || !this.props[this.props.registry].isPrefilledDataLoaded)
            return <Circles />

        if (this.props[this.props.registry].isFormRendered === true && this.props[this.props.registry].requestResult === true)
            return <Redirect to={this.props.path.replace(/^(.*)\/.*$/, '$1/results')} />;

        const data = { ...this.state.prefilledData, ...this.props[this.props.registry].prefilledData };

        var minAmlDate = moment('1901-01-01').format("l");
        var maxAmlDate = moment('2099-12-31').format("l");
        const wrongAmlDateMsg = this.props.translate("Search.Common.Validation.WrongAmlDate").replace('{min}', minAmlDate).replace('{max}', maxAmlDate);
        const wrongAmlYearMsg = this.props.translate("Search.Common.Validation.WrongAmlYear");

        return (
            <Formik
                ref={(el) => this.formRef = el}
                enableReinitialize
                validationSchema={this.createValidationSchema(this.props.registry)}
                validateOnChange={false}
                validateOnBlur={false}
                initialValues={{
                    birthId: isNullOrUndefined(data) ? '' : (data.type === null ? data.pin : ''),
                    fullName: isNullOrUndefined(data) || data.type === SEARCH_TYPE.po ? '' : data.name || '', // Fill name in every type case (FO, FOP, null) except PO
                    birthDate: isNullOrUndefined(data) || data.type !== SEARCH_TYPE.fo ? '' : !isNullOrUndefined(data.dob) ? this.props.registry == REGISTRY.aml ? moment(data.dob).format('DD.MM.YYYY') : data.dob : '' || '',
                    birthYear:  isNullOrUndefined(data) || data.type !== SEARCH_TYPE.fo ? '' : (isNullOrUndefined(data.dob) && !isNullOrUndefined(data.birthYear)) ? data.birthYear : '' || '',
                    poIco: isNullOrUndefined(data) || data.type !== SEARCH_TYPE.po ? '' : data.ico || '',
                    address: isNullOrUndefined(data) || this.props.registry !== REGISTRY.cee || data.type !== SEARCH_TYPE.fo ? '' : data.city || '',
                    companyName: '',
                    businessName: isNullOrUndefined(data) || data.type !== SEARCH_TYPE.fpo ? '' : data.businessName || '',
                    includeMonetary: false,
                    maxCauses: this.getFromCustomerSettings("MaxNumberOfCauses"),
                    maxTotalCauses: this.getFromCustomerSettings("MaxNumberOfDetails"),
                    minCauseDate: this.getFromCustomerSettings("CasesNotOlderThan"),
                    minCauseAmount: this.getFromCustomerSettings("MinMonetaryObligation"),
                    bulkFile: undefined,
                    bulkCheck: undefined,
                    amlCheck: undefined,
                    ceeCheck: undefined,
                    creCheck: undefined,
                    rpveCheck: undefined,
                    firstName: isNullOrUndefined(data) || data.type !== SEARCH_TYPE.fo || isNullOrUndefined(data.additionalData) ? '' : data.additionalData.name || '',
                    surname: isNullOrUndefined(data) || data.type !== SEARCH_TYPE.fo || isNullOrUndefined(data.additionalData) ? '' : data.additionalData.surname || '',
                    middleName: '',
                    city: isNullOrUndefined(data) || data.type !== SEARCH_TYPE.fo ? '' : data.city || '',
                    fpoCity: '',
                    year: this.getFromCustomerSettings("CasesNotOlderThan"),
                    gender: '',
                    foCountry: '',
                    fpoCountry: '',
                    poCountry: '',
                    trialFileNumber: '',
                    amlForceNew: true,
                    allowCustomer: true,
                    amlTree: hasPermission(null, "AMLPathToBeneficialUser") ? true : false,
                    amlShare: undefined,
                    bulkShare: undefined,
                    buttonPressed: ''
                }}
                onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(false); // 'loading' status is handled by Redux so immediately reset Formik's 'submitting' flag
                    this.submitForm(values);
                }}>
                {({ values, setFieldValue, errors, resetForm }) => (
                    <Form>
                        {this.renderErrors(values)}
                        {this.props.registryError === true && <Message type="error" message={this.props.translate("Common.Error")} style={{ marginTop: "1em" }} />}
                        {Object.keys(errors).length > 0 && <div className="column" style={{ paddingTop: "0em" }}>
                            <CeeErrorMessage errors={Object.keys(errors).filter(key => (errors[key] !== this.props.translate("Error.WrongInputCombination") &&
                                !(key === "birthDate" && this.props.registry === REGISTRY.aml) &&
                                !(key === "maxCauses" && errors[key] === this.props.translate("Search.Cee.ValidationError.MaxCauses"))))
                                .map(k => k.replace("Id", ""))} style={{ marginTop: "0.75em" }} />
                            {Object.keys(errors).find(key => (errors[key] === this.props.translate("Error.WrongInputCombination") &&
                                !(key === "birthDate" && this.props.registry === REGISTRY.aml) &&
                                !(key === "maxCauses" && errors[key] === this.props.translate("Search.Cee.ValidationError.MaxCauses")))) &&
                                <Message type="error" message={this.props.translate("Error.WrongInputCombination")} style={{ marginTop: "0.75em" }}></Message>
                            }
                            {Object.keys(errors).find(key => key === "birthDate" && this.props.registry === REGISTRY.aml) &&
                                <Message type="error" message={wrongAmlDateMsg} style={{ marginTop: "0.75em" }}></Message>
                            }
                            {Object.keys(errors).find(key => key === "birthYear" && this.props.registry === REGISTRY.aml) &&
                                <Message type="error" message={wrongAmlYearMsg} style={{ marginTop: "0.75em" }}></Message>
                            }
                            {Object.keys(errors).find(key => key === "maxCauses" && errors[key] === this.props.translate("Search.Cee.ValidationError.MaxCauses")) &&
                                <Message type="error" message={this.props.translate("Search.Cee.ValidationError.MaxCauses")} style={{ marginTop: "0.75em" }}></Message>
                            }
                        </div>}
                        {this.props.registry === REGISTRY.cee && this.state.selected === SEARCH_TYPE.fo && !isNullOrUndefined(this.props[this.props.registry].prefilledData) &&
                            <Message type="warning" message={this.props.translate("Search.Cee.CheckPrefilledData.Fop")} style={{ marginTop: "1em" }} />}
                        <div className="columns is-desktop">
                            <div className="column is-4-desktop tabs tabs-form-menu">
                                <FormMenuControl>
                                    <ul>
                                        {this.renderTabs(this.props.registry, resetForm)}
                                    </ul>
                                </FormMenuControl>
                            </div>
                            <div className='column'>
                                {this.hasSearchTips(this.props.registry, this.state.selected) &&
                                    <SearchTip windowId={`tips_${this.props.registry}_${this.state.selected}`} getSearchTipsModel={() => this.getSearchTipsModel(this.props.registry, this.state.selected, this.props[this.props.registry].prefilledData)} className="hide-on-mobile" style={{ marginBottom: '-0.5em', marginTop: '1em' }} />}
                                <div className='card card-special'>
                                    {this.hasSearchTips(this.props.registry, this.state.selected) &&
                                        <SearchTip windowId={`tips_${this.props.registry}_${this.state.selected}`} getSearchTipsModel={() => this.getSearchTipsModel(this.props.registry, this.state.selected, this.props[this.props.registry].prefilledData)} className="hide-on-desktop" style={{ marginBottom: '-2.5em', paddingTop: '1em', marginRight: '1em' }} />}
                                    <div className='card-body'>
                                        <div className='columns is-centered is-multiline'>
                                            <div className="column is-12" style={{ paddingBottom: "1.5em" }}>
                                                <div className="columns is-centered">
                                                    <div className="column is-12">
                                                        {this.state.selected === SEARCH_TYPE.fo && this.props.registry === REGISTRY.cee && this.renderCeeFoForm(values, setFieldValue)}
                                                        {this.state.selected === SEARCH_TYPE.fo && (this.props.registry === REGISTRY.cre || this.props.registry === REGISTRY.rpve) && this.renderCreFoForm(values, setFieldValue)}
                                                        {this.state.selected === SEARCH_TYPE.fo && this.props.registry === REGISTRY.aml && this.renderAmlFoForm(values, setFieldValue)}
                                                        {this.state.selected === SEARCH_TYPE.fpo && this.renderFpoForm(values)}
                                                        {this.state.selected === SEARCH_TYPE.po && this.props.registry === REGISTRY.cee && this.renderCeeCrePoForm(searchInstances.cee, values, setFieldValue, 1)}
                                                        {this.state.selected === SEARCH_TYPE.po && (this.props.registry === REGISTRY.cre || this.props.registry === REGISTRY.rpve) && this.renderCeeCrePoForm(searchInstances.cre, values, setFieldValue, 2)}
                                                        {this.state.selected === SEARCH_TYPE.po && this.props.registry === REGISTRY.aml && this.renderPoAmlForm(values, setFieldValue)}
                                                        {this.state.selected === SEARCH_TYPE.bulk && this.renderBulkSearchForm(setFieldValue, this.props.registry === REGISTRY.aml)}
                                                        {this.state.selected === SEARCH_TYPE.trialFile && this.renderCauseForm(values)}
                                                    </div>
                                                </div>
                                            </div>
                                            {(this.props.registry === REGISTRY.cee || this.props.registry === REGISTRY.cre || this.props.registry === REGISTRY.rpve) && this.state.selected !== SEARCH_TYPE.trialFile &&
                                                this.renderFormSettings(values, setFieldValue)}
                                            <FormButtonsRow disabled={!this.isSearchEnabled(values)} disabledRpve={!this.isSearchRPVEEnabled(values)} registry={this.props.registry} clickCallBack={(name) => { this.setBtn(name); setFieldValue('buttonPressed', name); }} selectedTab={this.state.selected} />
                                        </div>
                                    </div>
                                </div >
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        );
    }

    componentDidMount() {
        if (!this.state.mounted) {
            this.props.initCeeSearch(this.props.registry);
            this.props.searchFormLoaded(this.props.registry);
            this.setPrefilledData();
            this.setState({ mounted: true });
        }
    }

    componentWillUnmount() {
        this.props.searchFormLeaving(this.props.registry);
    }

    renderErrors = (values) => {
        if ((this.props[this.props.registry].requestResult === false &&
            !isNullOrUndefined(this.props[this.props.registry].responseData) && (
                !isNullOrUndefined(this.props[this.props.registry].responseData.exception) ||
                !isNullOrUndefined(this.props[this.props.registry].responseData.errorFile) ||
                !!this.props[this.props.registry].responseData.error
            )) || (!isNullOrUndefined(this.state.responseData) && (
                !isNullOrUndefined(this.state.responseData.exception) ||
                !isNullOrUndefined(this.state.responseData.errorFile) ||
                !!this.state.responseData.error
            ))
        ) {
            return (
                <div style={{ marginTop: "1em" }}>
                    {((!isNullOrUndefined(this.props[this.props.registry].responseData) && !isNullOrUndefined(this.props[this.props.registry].responseData.exception)) ||
                        (!isNullOrUndefined(this.state.responseData) && !isNullOrUndefined(this.state.responseData.exception))
                    ) && <Message type="error" message="">
                            {!isNullOrUndefined(this.state.responseData) && !!this.state.responseData.exception
                                ? <Translate options={{ renderInnerHtml: true }} id={this.state.responseData.exception}
                                    data={isNullOrUndefined(this.state.responseData.exceptionData) ? undefined : this.state.responseData.exceptionData}
                                />
                                : <Translate options={{ renderInnerHtml: true }} id={this.props[this.props.registry].responseData.exception}
                                    data={isNullOrUndefined(this.props[this.props.registry].responseData.exceptionData)
                                        ? undefined : this.props[this.props.registry].responseData.exceptionData}
                                />}
                        </Message>}
                    {((!isNullOrUndefined(this.props[this.props.registry].responseData) && !!this.props[this.props.registry].responseData.error) ||
                        (!isNullOrUndefined(this.state.responseData) && !!this.state.responseData.error)
                    ) && <Message type="error" message="">
                            {!isNullOrUndefined(this.state.responseData) && !!this.state.responseData.error
                                ? <Translate options={{ renderInnerHtml: true }} id={isNullOrUndefined(this.state.responseData.error.message)
                                    ? this.state.responseData.error : this.state.responseData.error.message} />
                                : <Translate options={{ renderInnerHtml: true }} id={isNullOrUndefined(this.props[this.props.registry].responseData.error.message)
                                    ? this.props[this.props.registry].responseData.error : this.props[this.props.registry].responseData.error.message} />}
                        </Message>}
                    {((!isNullOrUndefined(this.props[this.props.registry].responseData) && !isNullOrUndefined(this.props[this.props.registry].responseData.errorFile)) ||
                        (!isNullOrUndefined(this.state.responseData) && !isNullOrUndefined(this.state.responseData.errorFile))
                    ) && <Message type="error" message="">
                            <>
                                <Translate id={`Search.${this.props.registry === REGISTRY.cee ? 'Cee' : 'Common'}.Bulk.ErrorFile`} />
                                <a href={this.getBulkTempFileUrl(!isNullOrUndefined(this.state.responseData.errorFile)
                                    ? this.state.responseData.errorFile : this.props[this.props.registry].responseData.errorFile)}
                                    target="_blank"
                                >
                                    <Translate id='Search.Common.Bulk.ErrorFileLink' />
                                </a>
                            </>
                        </Message>
                    }
                </div>
            );
        }
    }

    getDateFieldValue(fieldName, date, setFieldValue) {

        if (moment(date, ["DD.MM.YYYY", "D.M.YYYY"], true).isValid()) {
            let formattedDate = moment(date, ["DD.MM.YYYY", "D.M.YYYY"]).format("YYYY-MM-DD");
            setFieldValue(fieldName, formattedDate);
        }
        else if (date === "") {
            setFieldValue(fieldName, "");
        }
    }

    renderCeeFoForm = (values, setFieldValue) => {
        return (
            <>
                <BbInput label={this.props.translate('Search.Common.Pid')} name="birthId" type="text" placeholder={{ type: 'column' }} />
                <BbInput label={this.props.translate('Search.Common.FullName')} name='fullName' type="text" placeholder={{ type: 'column' }} />
                <BbInput type='custom' label={this.props.translate('Search.Common.BirthDate')}
                    placeholder={{ type: 'column' }}
                    custom={
                        <BbDatePicker
                            value={values.birthDate}
                            afterDateChange={(date) => this.getDateFieldValue('birthDate', date, setFieldValue)}
                            name="birthDate"
                            formDateFormat={"YYYY-MM-DD"}
                            yearsBack={120} />
                    }
                />
                <BbInput type='text' name='address' label={this.props.translate('Search.Common.Address')} placeholder={{ type: 'column' }} />
            </>
        );
    }

    renderCreFoForm = (values, setFieldValue) => {
        return (
            <>
                {hasPermission(null, "SearchCREPin") && <BbInput label={this.props.translate('Search.Common.Pid')} name="birthId" type="text" placeholder={{ type: 'column' }} />}
                <BbInput type='text' name='firstName' label={this.props.translate('Search.Common.FirstName')} placeholder={{ type: 'column' }} />
                <BbInput type='text' name='surname' label={this.props.translate('Search.Common.Surname')} placeholder={{ type: 'column' }} />
                <BbInput type='custom' label={this.props.translate('Search.Common.BirthDate')} name="birthDate"
                    placeholder={{ type: 'column' }} custom={
                        <BbDatePicker
                            afterDateChange={(date) => this.getDateFieldValue('birthDate', date, setFieldValue)}
                            name="birthDate"
                            value={values.birthDate}
                            formDateFormat={"YYYY-MM-DD"}
                            yearsBack={120}
                            showError={true}
                            field={'birthDate'}
                        />
                    }
                />
                <BbInput type='text' name='city' label={this.props.translate('Search.Common.Municipality')} placeholder={{ type: 'column' }} />
            </>
        );
    }

    renderAmlFoForm = (values, setFieldValue) => {
        return (
            <>
                <BbInput type='text' name='firstName' label={this.props.translate('Search.Common.FirstName')} placeholder={{ type: 'column' }} />
                <BbInput type='text' name='middleName' label={this.props.translate('Search.Aml.MiddleName')} placeholder={{ type: 'column' }} />
                <BbInput type='text' name='surname' label={this.props.translate('Search.Common.Surname')} placeholder={{ type: 'column' }} />

                <div className='field bb-field'>
                    <div className='columns'>
                        <div className='column is-4 bb-input-label-column'>
                            <div className="label-wrapper">
                                <span className="marketing-label">
                                    <Translate id='Search.Common.BirthDate' />
                                </span>
                            </div>
                        </div>
                        <div className="is-flex w-100">
                            <div className='column is-6 bb-input-column'>
                                <BbDatePicker
                                    afterDateChange={(date) => this.getDateFieldValue('birthDate', date, setFieldValue)}
                                    name="birthDate"
                                    value={values.birthDate}
                                    formDateFormat={"DD.MM.YYYY"}
                                    yearsBack={new Date().getFullYear() - 1901}
                                    disabled={!isNullOrUndefined(values.birthYear) && values.birthYear !== ""}
                                />
                            </div>
                            <div className='column is-6 bb-input-column'>
                                <BbInput type='number'
                                    name='birthYear'
                                    label={this.props.translate("Search.Common.OrBirthYear")}
                                    placeholder={{ type: 'column' }}
                                    disabled={!isNullOrUndefined(values.birthDate) && values.birthDate.length > 0}
                                    showError={false}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <BbInput type='radio' label={this.props.translate('Search.Common.Gender')} placeholder={{ type: 'column' }}
                    options={[
                        { value: 'M', label: 'Search.Common.Gender.Male' },
                        { value: 'F', label: 'Search.Common.Gender.Female' }
                    ]} checkedValue={values.gender} callback={(val) => setFieldValue('gender', val)}
                />

                <BbInput type='text' name='city' label={this.props.translate('Search.Common.City')} placeholder={{ type: 'column' }} />
                <BbInput type='custom' label={this.props.translate('Report.Aml.Subjects.Domicil')}
                    placeholder={{ type: 'column' }} custom={<CountryField country={values.foCountry} fieldName='foCountry' />} />
            </>
        );
    }

    renderFpoForm = (values) => {
        return (
            <>
                <BbInput type='text' name='businessName' label={this.props.translate('Search.Common.BusinessName')} placeholder={{ type: 'column' }} />
                <BbInput type='text' name='fpoCity' label={this.props.translate('Search.Common.City')} placeholder={{ type: 'column' }} />
                <BbInput type='custom' label={this.props.translate('Report.Aml.Subjects.Domicil')}
                    placeholder={{ type: 'column' }} custom={<CountryField country={values.fpoCountry} fieldName='fpoCountry' />} />
            </>
        );
    }

    renderCeeCrePoForm = (searchInstanceKey, values, setFieldValue, marketAttribute) => {
        return (
            <>
                <RelationsSearchInstance
                    instanceKey={searchInstanceKey}
                    onEntityCheck={(foundEntities) => this.onEntityCheck(searchInstanceKey, foundEntities[0], values, setFieldValue)}
                    scroller={this.props.scroller}
                    checkType={"none"}
                    marketAttribute={marketAttribute}
                />
                <BbInput type='text' name='poIco' label={this.props.translate('Search.Common.CompanyId')} placeholder={{ type: 'column' }} />
                <BbInput type='text' name='companyName' label={this.props.translate('Search.Common.CompanyName')} placeholder={{ type: 'column' }} />
            </>
        );
    }

    onEntityCheck = (searchInstanceKey, entityId, values, setFieldValue) => {
        if (!isNullOrUndefined(entityId)) {
            let subject = this.props.relationsSearch[searchInstanceKey].searchResult.data.subjects.filter(x => x.entityId === entityId)[0];
            setFieldValue("poIco", subject.ico.replace("<em>", "").replace("</em>", ""));
            setFieldValue("companyName", "");
            if (this.props.registry === REGISTRY.aml)
                setFieldValue("poCountry", subject.country);
        }
    }

    renderPoAmlForm = (values, setFieldValue) => {
        return (
            <>
                <RelationsSearchInstance
                    instanceKey={searchInstances.aml}
                    onEntityCheck={(foundEntities) => this.onEntityCheck(searchInstances.aml, foundEntities[0], values, setFieldValue)}
                    scroller={this.props.scroller}
                    checkType={"none"}
                    marketAttribute={3}
                />
                <BbInput type='text' name='poIco' label={this.props.translate('Search.Common.CompanyId')} placeholder={{ type: 'column' }} />
                <BbInput type='custom' label={this.props.translate('Report.Aml.Subjects.Country')}
                    placeholder={{ type: 'column' }} custom={
                        <CountryField
                            fieldName='poCountry'
                            country={values.poCountry}
                            filter={country => country.value.toLowerCase() === 'sk' || country.value.toLowerCase() === 'cz'} />
                    }
                />

                {hasPermission(null, "AMLPathToBeneficialUser") && <BbInput type='custom' label={this.props.translate('Search.Aml.AmlTree.Label')}
                    placeholder={{ type: 'column' }} custom={
                        <BbCheckbox
                            value={values.amlTree}
                            id={'amlTree'}
                            name={'amlTree'}
                            onChange={c => {
                                this.props.formik.setFieldValue('amlTree', c)
                            }}
                        />
                    }
                />}
                {this.renderSharePctRow('poShare')}
            </>
        );
    }

    renderSharePctRow = (inputName) => {
        if (hasPermission(null, "AMLBeneficialUserPercentage") && !hasPermission(null, "EconomicGroupSberbankMethodology"))
            return <div className='field bb-field' style={{ textAlign: 'left' }}>
                <div className='columns'>
                    <div className='column is-4 bb-input-label-column'>
                        <div className="label-wrapper">
                            <span className="marketing-label">
                                <Translate id='User.Settings.ESS.MinimalOwnershipInterest' />
                            </span>
                        </div>
                    </div>
                    <div className='column bb-input-column is-7'>
                        <BbInput
                            type='number'
                            name={inputName}
                            placeholder={{ type: 'inline' }}
                            label={this.props.translate('Search.Aml.Share.PickOrDefault')}
                            title={this.props.translate('Search.Aml.Share.PickOrDefault')}
                            min={ESS_MIN}
                            max={ESS_MAX}
                        />
                    </div>
                    <div className='column bb-input-label-column is-1'>
                        <span className="vertically-centered">%</span>
                    </div>
                </div>
            </div>
        else
            return null;
    }

    renderBulkSearchForm = (setFieldValue, isAml = false) => {
        return (
            <div className="tile is-ancestor">
                <div className="tile is-vertical" >
                    <div className="columns is-centered has-text-centered">
                        <div className="column is-12">
                            <div className="tile is-parent is-vertical">
                                <div className="tile is-child">
                                    <label>
                                        <b>
                                            <Translate id='Search.Common.BulkFile' />
                                        </b>
                                    </label>
                                </div>
                                <div className="tile is-child">
                                    <label>
                                        <Translate id='Search.Common.BulkFile.Info' />
                                    </label>
                                </div>
                                <div className="tile is-child">
                                    <FileUpload className="fileupload-button" customLabel={true} name='bulkFile'
                                        callback={(result) => setFieldValue("bulkFile", result)}
                                    >
                                        <a className="link-functional" id="bulk_template"
                                            href={this.getBulkTemplateUrl(this.props.registry, this.props.activeLanguage.code)}
                                            style={{ padding: "1em" }}
                                        >
                                            <Translate id='Search.Common.BulkTemplate' />
                                        </a>
                                    </FileUpload>
                                </div>

                                {isAml && this.renderSharePctRow('bulkShare')}
                                {isAml && <div className="tile" style={{ textAlign: 'left' }}>
                                    <span className="aml-special-span" style={{ lineHeight: "1.5em" }}>
                                        <BbCheckbox style={{ display: "inline-flex", minHeight: "0px", verticalAlign: "middle", fontWeight: "bold" }}
                                            id='amlForceNew'
                                            name='amlForceNew'
                                            value={true}
                                            label={this.props.translate("Aml.BulkRequest.ForceNew.Label")} />
                                    </span>
                                </div>
                                }
                                {isAml && hasPermission(null, "AMLReuseRequest") && <div className="tile" style={{ textAlign: 'left' }}>
                                    <span className="aml-special-span" style={{ lineHeight: "1.5em" }}>
                                        <BbCheckbox style={{ display: "inline-flex", minHeight: "0px", verticalAlign: "middle", fontWeight: "bold" }}
                                            id='allowCustomer'
                                            name='allowCustomer'
                                            checkedValue
                                            value={true}
                                            label={this.props.translate("Aml.BulkRequest.AllowCustomer.Label")}
                                        />
                                    </span>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderCauseForm = () =>
        <BbInput type='text' name='trialFileNumber' label={this.props.translate('Search.Common.TrialFileNumber')} placeholder={{ type: 'column' }} />

    renderFormSettings = (values, setFieldValue) => {
        return ((this.props.registry === REGISTRY.cee && hasPermission(null, "CEEenhancedCz")) || ((this.props.registry === REGISTRY.cre || this.props.registry === REGISTRY.rpve) && hasPermission(null, "CREEnhancedSk"))) && (
            <div className="column is-12 has-text-centered" style={{ borderTop: "1px solid rgb(222, 222, 222)", paddingTop: "1.5em" }}>
                <UnderlinedTitle header={this.props.translate("Search.Common.MonetaryInfoAutodownload")} />
                <div className="columns is-mobile" style={{ marginTop: ".1em", marginBottom: "0em" }}>
                    <div className="column" style={{ display: "flex", lineHeight: "3em", alignItems: "center", flexWrap: "wrap" }}>
                        <span className="aml-special-span" >
                            <BbCheckbox style={{ display: "inline-flex", minHeight: "0px", lineHeight: "3em", verticalAlign: "middle" }}
                                id='includeMonetary'
                                name='includeMonetary'
                                value={values.includeMonetary}
                                label={this.props.translate("Search.Common.DownloadMonetaryObligationPart1")} />
                            <Field
                                className="input"
                                type='number'
                                min={CAUSES_MIN}
                                max={CAUSES_MAX}
                                name="maxCauses"
                                style={{ maxWidth: '4em', display: 'inline-block', marginLeft: '.5em', marginRight: '.5em', textAlign: "center" }}
                                disabled={!values.includeMonetary}
                                onChange={e => this.onNumberChanged("maxCauses", e.target.value, setFieldValue, CAUSES_MIN, CAUSES_MIN, CAUSES_MAX)}
                            />
                            <span>
                                <Translate id='Search.Common.DownloadMonetaryObligationPart2' />
                                <Translate id='Search.Common.DownloadMonetaryObligationPart3' />
                            </span>
                        </span>
                    </div>
                </div>
                <div className="columns is-mobile has-text-left">
                    <div className="column is-12">
                        <div className={classnames({ "inactive-input-font-color": !values.includeMonetary })}>
                            <div className='field bb-field'>
                                <div className="control">
                                    <div className="columns">
                                        <div className="column column bb-input-label-column is-one-third">
                                            <div className="vertically-centered">
                                                <div className={classnames({ "inactive-input-font-color": !values.includeMonetary })}>
                                                    <span><Translate id="Search.Common.TotalNumberOfCasesNotExceeding" /></span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="column bb-input-column is-two-thirds">
                                            <Field
                                                className="bb-input-expanded input form-control"
                                                type="number"
                                                min={CAUSES_MIN}
                                                max={CAUSES_MAX_TOTAL}
                                                name="maxTotalCauses"
                                                disabled={!values.includeMonetary}
                                                onChange={e => this.onNumberChanged("maxTotalCauses", e.target.value, setFieldValue, null, CAUSES_MIN, CAUSES_MAX_TOTAL)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {this.props.registry === REGISTRY.cee && <div className='field bb-field'>
                            <div className="control">
                                <div className="columns">
                                    <div className="column column bb-input-label-column is-one-third">
                                        <div className="vertically-centered">
                                            <div className={classnames({ "inactive-input-font-color": !values.includeMonetary })}>
                                                <span><Translate id="Search.Common.CaseNotOlderThan" /></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="column bb-input-column is-two-thirds">
                                        <BbDatePicker
                                            formik={this.formRef}
                                            field={'minCauseDate'}
                                            value={values.minCauseDate}
                                            disabled={!values.includeMonetary}
                                            formDateFormat={"YYYY-MM-DD"}
                                            yearsBack={120}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>}
                        {(this.props.registry === REGISTRY.cre || this.props.registry === REGISTRY.rpve) && <div className={classnames({ "inactive-input-font-color": !values.includeMonetary })}>
                            <div className='field bb-field'>
                                <div className="control">
                                    <div className="columns">
                                        <div className="column column bb-input-label-column is-one-third">
                                            <div className="vertically-centered">
                                                <div className={classnames({ "inactive-input-font-color": !values.includeMonetary })}>
                                                    <span><Translate id="Search.Common.CaseNotOlderThan" /></span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="column bb-input-column is-two-thirds">
                                            <Field
                                                className="bb-input-expanded input form-control"
                                                type="number"
                                                min={YEAR_MIN}
                                                max={new Date().getFullYear()}
                                                name="year"
                                                disabled={!values.includeMonetary}
                                                onChange={e => this.onNumberChanged("year", e.target.value, setFieldValue, null, YEAR_MIN, new Date().getFullYear())}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>}
                        {this.props.registry === REGISTRY.cee && <div className={classnames({ "inactive-input-font-color": !values.includeMonetary })}>
                            <div className='field bb-field'>
                                <div className="control">
                                    <div className="columns">
                                        <div className="column column bb-input-label-column is-one-third">
                                            <div className="vertically-centered">
                                                <div className={classnames({ "inactive-input-font-color": !values.includeMonetary })}>
                                                    <span><Translate id="Search.Cee.MinAmountOfMonetaryObligationPart1" /></span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="column bb-input-column is-two-thirds">
                                            <Field
                                                className="bb-input-expanded input form-control"
                                                type="number"
                                                min={CAUSE_AMOUNT_MIN}
                                                max={CAUSE_AMOUNT_MAX}
                                                name="minCauseAmount"
                                                disabled={!values.includeMonetary}
                                                onChange={e => this.onNumberChanged("minCauseAmount", e.target.value, setFieldValue, null, CAUSE_AMOUNT_MIN, CAUSE_AMOUNT_MAX)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>}
                    </div>
                </div>
            </div>
        );
    }

    renderTabs = (registry, resetForm) => {
        const tabs = this.getTabs(registry);

        return (
            <>
                {tabs.map(tab => <TabLink type={tab.type} selected={this.state.selected} onSelect={(value) => {
                    this.selectSearch(value);
                    this.setState({ bulkCheck: undefined, amlCheck: undefined, ceeCheck: undefined, creCheck: undefined, rpveCheck: undefined, responseData: undefined }); resetForm();
                }} icon={tab.icon}
                    titleKey={tab.titleKey} key={tab.titleKey} descriptionKey={tab.descriptionKey} hr={tab.hr} />)}
            </>
        );
    }

    selectSearch = (selected) => {
        if (selected !== this.state.selected) {
            this.setState({ selected: selected });
            this.props.closeAll();
        }
    }

    confirmationPopup = (values, notFound = false, isFop = false, forceNewRequest = false) => {
        this.props.showPopup('ceeConfirmation', {
            title: this.props.translate('Search.Common.Warning'),
            open: true,
            style: { display: "block", flex: "initial" },
            close: () => { this.props.hidePopup(); },
            no: () => this.props.hidePopup(),
            yes: () => this.yesOnConfirmationAction(values, forceNewRequest),
            formData: { // it is needed to take into account that all sections (fo, po, fpo) are under the single form - for example it is needed to prevent
                // from showing company name field from 'po' section in 'fo' section confirmation dialog
                birthId: this.state.selected !== SEARCH_TYPE.fo || values.birthId === undefined || values.birthId.trim() === '' ? undefined : values.birthId.trim(),
                fullName: this.state.selected !== SEARCH_TYPE.fo || values.fullName === undefined || values.fullName.trim() === '' ? undefined : values.fullName.trim(),
                birthDate: this.state.selected !== SEARCH_TYPE.fo || values.birthDate === '' ? undefined : moment(values.birthDate, "DD.MM.YYYY", true).isValid() ? moment(values.birthDate, "DD.MM.YYYY").format("YYYY-MM-DD") : values.birthDate,
                birthYear: this.state.selected !== SEARCH_TYPE.fo || values.birthYear === '' ? undefined : values.birthYear,
                ico: this.state.selected !== SEARCH_TYPE.po || values.poIco.trim() === '' ? undefined : values.poIco.replace(/\s/g, ''),
                address: this.state.selected !== SEARCH_TYPE.fo || values.address.trim() === '' ? undefined : values.address.trim(),
                companyName: this.state.selected !== SEARCH_TYPE.po || values.companyName.trim() === '' ? undefined : values.companyName.trim(),
                businessName: this.state.selected !== SEARCH_TYPE.fpo || values.businessName.trim() === '' ? undefined : values.businessName.trim(),
                firstName: this.state.selected !== SEARCH_TYPE.fo || values.firstName.trim() === '' ? undefined : values.firstName.trim(),
                surname: this.state.selected !== SEARCH_TYPE.fo || values.surname.trim() === '' ? undefined : values.surname.trim(),
                middleName: this.state.selected !== SEARCH_TYPE.fo || values.middleName.trim() === '' ? undefined : values.middleName.trim(),
                notFound: notFound,
                isFop: isFop,
                city: ((selected, values) => {
                    switch (selected) {
                        case SEARCH_TYPE.fo: return values.city.trim() === '' ? undefined : values.city.trim();
                        case SEARCH_TYPE.fpo: return values.fpoCity.trim() === '' ? undefined : values.fpoCity.trim();
                        default: return undefined;
                    }
                })(this.state.selected, values),
                gender: this.state.selected !== SEARCH_TYPE.fo || values.gender === '' ? undefined : values.gender,
                country: ((selected, values) => {
                    switch (selected) {
                        case SEARCH_TYPE.fo: return values.foCountry === '' ? undefined : values.foCountry;
                        case SEARCH_TYPE.fpo: return values.fpoCountry === '' ? undefined : values.fpoCountry;
                        case SEARCH_TYPE.po: return values.poCountry === '' ? undefined : values.poCountry;
                        default: return undefined;
                    }
                })(this.state.selected, values),
                trialFileNumber: this.state.selected !== SEARCH_TYPE.trialFile || values.trialFileNumber.trim() === '' ? undefined : values.trialFileNumber.trim(),
                share: this.props.registry !== REGISTRY.aml || this.state.selected !== SEARCH_TYPE.po || values.poShare === '' ? undefined : values.poShare,
                bulkShare: this.props.registry !== REGISTRY.aml || this.state.selected !== SEARCH_TYPE.bulk || values.bulkShare === '' ? undefined : values.bulkShare
            },
            includeMonetary: values.includeMonetary,
            maxCauses: values.maxCauses === '' ? undefined : values.maxCauses,
            monetaryData: values.includeMonetary === true ? {
                maxTotalCauses: values.maxTotalCauses === '' ? undefined : values.maxTotalCauses,
                minCauseDate: this.props.registry !== REGISTRY.cee || values.minCauseDate === '' ? undefined : values.minCauseDate,
                minCauseAmount: values.minCauseAmount === '' ? undefined : values.minCauseAmount,
                year: this.props.registry !== REGISTRY.cre || values.year === '' ? undefined : values.year
            } : undefined,
            requestType: this.state.selected,
            bulkFile: values.bulkFile,
            forceNew: this.props.registry === REGISTRY.aml ? values.amlForceNew : false,
            allowCustomer: this.props.registry === REGISTRY.aml ? values.allowCustomer : false,
            bulkCheck: this.state.bulkCheck,
            amlCheck: this.state.amlCheck,
            ceeCheck: this.state.ceeCheck,
            creCheck: this.state.creCheck,
            rpveCheck: this.state.rpveCheck,
            registry: this.submittedRegistry()
        });
    }

    //used for posting data
    getMonetaryInfoFromForm = formValues =>
        formValues.includeMonetary === true ? {
            isChecked: true,
            maxCauses: formValues.maxCauses === '' ? null : formValues.maxCauses,
            maxTotalCauses: formValues.maxTotalCauses === '' ? null : formValues.maxTotalCauses,
            minCauseDate: this.props.registry === REGISTRY.cee ?
                formValues.minCauseDate === '' ? null : formValues.minCauseDate :
                formValues.year === '' ? null : moment(new Date(parseInt(formValues.year), 0, 1, 0, 0, 0, 0)).format("YYYY-MM-DD"),
            minCauseAmount: formValues.minCauseAmount === '' ? null : formValues.minCauseAmount
        } : null;

    yesOnConfirmationAction = (formValues, forceNewRequest = false) => {
        this.props.hidePopup();

        let searchData = this.generateDataForServer(formValues, forceNewRequest);

        switch (this.state.selected) {
            case SEARCH_TYPE.fo:
                this.props.initiateCeeRequestOnFo(this.props.registry, this.submittedRegistry(), searchData);
                break;
            case SEARCH_TYPE.po:
                this.props.initiateCeeRequestOnPo(this.props.registry, this.submittedRegistry(), searchData);
                break;
            case SEARCH_TYPE.fpo:
                this.props.initiateCeeRequestOnFpo(this.props.registry, this.submittedRegistry(), searchData);
                break;
            case SEARCH_TYPE.bulk:
                this.props.initiateCeeRequestBulk(this.props.registry, this.submittedRegistry(), {
                    fileName: formValues.bulkFile.fileName,
                    fileBytes: formValues.bulkFile.fileBytes,
                    contentType: formValues.bulkFile.contentType,
                    monetaryInfo: this.getMonetaryInfoFromForm(formValues),
                    forceNew: !formValues.amlForceNew,
                    allowCustomer: formValues.allowCustomer,
                    bulkShare: formValues.bulkShare
                });
                break;
            case SEARCH_TYPE.trialFile:
                this.props.initiateCeeRequestOnTrialFile(this.props.registry, this.submittedRegistry(), searchData);
                break;
            default:
                break;
        }
    }

    generateDataForServer = (formValues, forceNewRequest = false) => {
        let searchData = {}

        if (this.props.registry === REGISTRY.cee || this.props.registry === REGISTRY.cre) {
            searchData.monetaryInfo = this.state.selected === SEARCH_TYPE.trialFile ? undefined : this.getMonetaryInfoFromForm(formValues);
        }

        switch (this.state.selected) {
            case SEARCH_TYPE.fo:
                if (this.props.registry === REGISTRY.cre || this.props.registry === REGISTRY.aml) {
                    searchData.firstName = formValues.firstName.trim() === '' ? null : formValues.firstName.trim();
                    searchData.surname = formValues.surname.trim() === '' ? null : formValues.surname.trim();
                    searchData.city = formValues.city.trim() === '' ? null : formValues.city.trim();
                }
                if (this.props.registry === REGISTRY.aml) {
                    searchData.middleName = formValues.middleName.trim() === '' ? null : formValues.middleName.trim();
                    searchData.gender = formValues.gender === '' ? null : formValues.gender;
                    searchData.country = formValues.foCountry === '' ? null : formValues.foCountry;
                    searchData.forceNewRequest = forceNewRequest;
                }
                if (this.props.registry === REGISTRY.cre || this.props.registry === REGISTRY.cee) {
                    searchData.birthId = formValues.birthId.trim() === '' ? null : formValues.birthId.trim().replace('/', '');
                }
                if (this.props.registry === REGISTRY.cee) {
                    searchData.fullName = isNullOrUndefined(formValues.fullName) || formValues.fullName.trim() === '' ? null : formValues.fullName.trim();
                    searchData.address = formValues.address.trim() === '' ? null : formValues.address.trim();
                }

                searchData.birthYear = isNullOrUndefined(formValues.birthYear) || formValues.birthYear === '' ? null : formValues.birthYear;
                searchData.birthDate = isNullOrUndefined(formValues.birthDate) || formValues.birthDate === '' ? null : moment(formValues.birthDate, "DD.MM.YYYY", true).isValid() ? moment( formValues.birthDate, "DD.MM.YYYY").format("YYYY-MM-DD") : formValues.birthDate;

                break;
            case SEARCH_TYPE.po:
                searchData.ico = formValues.poIco.trim() === '' ? null : formValues.poIco.replace(/\s/g, '');
                if (this.props.registry === REGISTRY.cre || this.props.registry === REGISTRY.cee) {
                    searchData.name = formValues.companyName.trim() === '' ? null : formValues.companyName.trim();
                }
                if (this.props.registry === REGISTRY.aml) {
                    searchData.country = formValues.poCountry === '' ? null : formValues.poCountry;
                    searchData.amlTree = formValues.amlTree;
                    searchData.forceNewRequest = forceNewRequest;
                    searchData.share = formValues.poShare;
                }
                break;
            case SEARCH_TYPE.fpo:
                searchData.name = formValues.businessName.trim() === '' ? null : formValues.businessName.trim();
                searchData.city = formValues.fpoCity.trim() === '' ? null : formValues.fpoCity.trim();
                searchData.country = formValues.fpoCountry === '' ? null : formValues.fpoCountry;
                if (this.props.registry === REGISTRY.aml) {
                    searchData.forceNewRequest = forceNewRequest;
                }
                break;
            case SEARCH_TYPE.trialFile:
                searchData.trialFileNumber = formValues.trialFileNumber.trim() === '' ? null : formValues.trialFileNumber.trim()
                break;
            default:
                break;
        }
        return searchData;
    }

    submittedRegistry = () => {
        if (this.props.registry !== REGISTRY.cre)
            return this.props.registry;
        else if (this.buttonPressed === REGISTRY.rpve)
            return REGISTRY.rpve;
        else
            return this.props.registry;
    }

    decisionPopup = (values, generatedDataForServer, requestDate, continuePath) => {
        this.props.showPopup('ceeDecision', {
            title: this.props.translate('Common.Information'),
            open: true,
            close: () => { this.props.hidePopup(); },
            requestDate: requestDate,
            continue: () => {
                //re-use the old request  
                if (!isNullOrUndefined(continuePath) && continuePath !== '')
                    this.props.history.push(continuePath);
                else
                    this.props.hidePopup();
            },
            newRequest: () => {
                this.props.hidePopup();
                generatedDataForServer.forceNewRequest = true;
                //check credit to get accurate price and create a new request
                apiPost(
                    `${getHostApi()}/api/search/${this.submittedRegistry()}/check/${this.state.selected}`,
                    null,
                    generatedDataForServer,
                    (data) => {
                        this.setState({ [`${this.submittedRegistry()}Check`]: data.data });
                        if (data.data.isSuccess) {
                            if (isNullOrUndefined(data.data.requestId))
                                this.confirmationPopup(values, false, false, true);
                            else
                                this.props.history.push(continuePath);
                        } else
                            this.onError(data.data);
                    },
                    (data) => this.onError(data.data)
                );
            }
        });
    }

    onError = (data) => this.setState({ responseData: data });

    exception = (ex) => {
        if (isNullOrUndefined(ex)) return null;
        return <div className='pl-5'>
            <div>{ex.Message}</div>
            <div>{ex.StackTrace}</div>
            {!isNullOrUndefined(ex.InnerException) && this.exception(ex.InnerException)}
        </div>
    }

    getBulkTemplateUrl(registry, languageCode) {
        const reg = Object.keys(REGISTRY).find(k => REGISTRY[k] === registry);
        const langCode = isValidLanguage(languageCode) ? languageCode : "sk-SK";
        return isNullOrUndefined(reg) ? "#" : `${getHostApi()}/api/search/bulk/template/${REGISTRY[reg]}/${langCode}`;
    }

    getBulkTempFileUrl(file) {
        return !isGuid(file) ? "#" : `${getHostUrl()}/files/bulk/error/${file}`;
    }

    getBulkCheckUrl(registry) {
        return `${getHostApi()}/api/search/${registry}/bulk/check`;
    }

    setBtn = (name) => {
        this.buttonPressed = name;
    }

    submitForm = (values) => {
        if (this.state.selected === SEARCH_TYPE.bulk) {
            this.setState({ responseData: undefined }); //reset previous response data
            //for bulk requests, we need to validate the input file and check credit for maximum possible price
            apiPost(
                this.getBulkCheckUrl(this.submittedRegistry()),
                null,
                {
                    fileName: values.bulkFile.fileName,
                    fileBytes: values.bulkFile.fileBytes,
                    contentType: values.bulkFile.contentType,
                    monetaryInfo: this.getMonetaryInfoFromForm(values),
                    forceNew: this.props.registry === REGISTRY.aml ? !values.amlForceNew : false,
                    allowCustomer: this.props.registry === REGISTRY.aml ? values.allowCustomer : false,
                    bulkShare: this.props.registry === REGISTRY.aml ? values.bulkShare : undefined
                },
                (data) => {
                    this.setState({ bulkCheck: data.data });
                    if (data.data.isSuccess)
                        this.confirmationPopup(values);
                    else
                        this.onError(data.data);
                },
                (data) => this.onError(data.data)
            );
        }
        else if (this.props.registry === REGISTRY.aml) {
            this.setState({ responseData: undefined }); //reset previous response data
            const selected = this.state.selected;
            let generatedDataForServer = this.generateDataForServer(values);
            //check AML credit to get accurate price (and remaining
            apiPost(
                `${getHostApi()}/api/search/aml/check/${selected === SEARCH_TYPE.po ? values.amlTree ? 'path' : 'po' : this.state.selected}`,
                null,
                generatedDataForServer,
                (data) => {
                    this.setState({ amlCheck: data.data });
                    if (data.data.isSuccess) {
                        if (isNullOrUndefined(data.data.id) || (selected !== SEARCH_TYPE.po && selected !== SEARCH_TYPE.fpo && selected !== SEARCH_TYPE.fo)) {
                            if (!isNullOrUndefined(data.data.companyName)) {
                                values.companyName = data.data.companyName;
                            }
                            this.confirmationPopup(values)
                        }
                        else {
                            const path = `/search/aml/results/${values.amlTree && selected === SEARCH_TYPE.po ? 'path' : selected === SEARCH_TYPE.po ? 'company' : 'person'}/${data.data.id}`;
                            if (data.data.isCustomerRequest)
                                this.decisionPopup(values, generatedDataForServer, data.data.requestDateFormatted, path);
                            else
                                this.props.history.push(path);
                        }
                    } else
                        this.onError(data.data)
                },
                (data) => this.onError(data.data)
            );
        }
        else if (this.props.registry === REGISTRY.cee) {
            this.setState({ responseData: undefined }); //reset previous response data
            let generatedDataForServer = this.generateDataForServer(values);
            //check CEE credit to get accurate price (and remaining
            apiPost(
                `${getHostApi()}/api/search/cee/check/${this.state.selected}`,
                null,
                generatedDataForServer,
                (data) => {
                    this.setState({ ceeCheck: data.data });
                    if (data.data.isSuccess) {
                        if (isNullOrUndefined(data.data.requestId))
                            this.confirmationPopup(values, data.data.notFound, data.data.isFop);
                        else {
                            const path = `/search/cee/results/${data.data.requestId}`;
                            if (data.data.isCustomerRequest)
                                this.decisionPopup(values, generatedDataForServer, data.data.requestDateFormatted, path);
                            else
                                this.props.history.push(path);
                        }
                    } else
                        this.onError(data.data);
                },
                (data) => this.onError(data.data)
            );
        }
        else {
            this.setState({ responseData: undefined }); //reset previous response data
            let generatedDataForServer = this.generateDataForServer(values);
            //check CRE/RPVE credit to get accurate price (and remaining
            apiPost(
                `${getHostApi()}/api/search/${this.submittedRegistry()}/check/${this.state.selected}`,
                null,
                generatedDataForServer,
                (data) => {
                    this.setState({ [`${this.submittedRegistry()}Check`]: data.data });
                    if (data.data.isSuccess) {
                        if (isNullOrUndefined(data.data.requestId))
                            this.confirmationPopup(values);
                        else {
                            const path = `/search/${this.submittedRegistry()}/results/${data.data.requestId}`;
                            if (data.data.isCustomerRequest)
                                this.decisionPopup(values, generatedDataForServer, data.data.requestDateFormatted, path);
                            else
                                this.props.history.push(path);
                        }
                    } else
                        this.onError(data.data);
                },
                (data) => this.onError(data.data)
            );
        }
    }

    hasSearchTips(registry, searchType) {
        switch (registry) {
            case REGISTRY.cee:
                switch (searchType) {
                    case SEARCH_TYPE.fo:
                    case SEARCH_TYPE.po:
                    case SEARCH_TYPE.bulk:
                    case SEARCH_TYPE.trialFile:
                        return true;
                    default:
                        return false;
                }
            case REGISTRY.cre:
                switch (searchType) {
                    case SEARCH_TYPE.fo:
                    case SEARCH_TYPE.po:
                    case SEARCH_TYPE.bulk:
                    case SEARCH_TYPE.trialFile:
                        return true;
                    default:
                        return false;
                }
            case REGISTRY.aml:
                switch (searchType) {
                    case SEARCH_TYPE.fo:
                    case SEARCH_TYPE.po:
                    case SEARCH_TYPE.bulk:
                    case SEARCH_TYPE.fpo:
                        return true;
                    default:
                        return false;
                }
            default:
                return false;
        }
    }

    getSearchTipsModel = (registry, searchType, prefilledData) => {
        switch (registry) {
            case REGISTRY.cee:
                switch (searchType) {
                    case SEARCH_TYPE.fo:
                        return { title: `${this.props.translate('Search.Common.PhysicalPerson')}`, bodyHtml: this.props.translate('SearchTips.CEE.FO.Body') };
                    case SEARCH_TYPE.po:
                        return { title: `${this.props.translate('Search.Common.Company')}`, bodyHtml: this.props.translate('SearchTips.CEE.PO.Body') };
                    case SEARCH_TYPE.bulk:
                        return { title: `${this.props.translate('Search.Common.Bulk')}`, bodyHtml: this.props.translate('SearchTips.CEE.Bulk.Body') };
                    case SEARCH_TYPE.trialFile:
                        return { title: `${this.props.translate('Search.Common.CauseSearch')}`, bodyHtml: this.props.translate('SearchTips.CEE.CaseId.Body') };
                    default:
                        return false;
                }
            case REGISTRY.cre:
                switch (searchType) {
                    case SEARCH_TYPE.fo:
                        return { title: `${this.props.translate('Search.Common.PhysicalPerson')}`, bodyHtml: this.props.translate('SearchTips.CRE.FO.Body') };
                    case SEARCH_TYPE.po:
                        return { title: `${this.props.translate('Search.Common.Company')}`, bodyHtml: this.props.translate('SearchTips.CRE.PO.Body') };
                    case SEARCH_TYPE.bulk:
                        return { title: `${this.props.translate('Search.Common.Bulk')}`, bodyHtml: this.props.translate('SearchTips.CRE.Bulk.Body') };
                    case SEARCH_TYPE.trialFile:
                        return { title: `${this.props.translate('Search.Common.CauseSearch')}`, bodyHtml: this.props.translate('SearchTips.CRE.CaseId.Body') };
                    default:
                        return false;
                }
            case REGISTRY.aml:
                switch (searchType) {
                    case SEARCH_TYPE.fo:
                        return { title: `${this.props.translate('Search.Common.PhysicalPerson')}`, bodyHtml: this.props.translate('SearchTips.AML.FO.Body') };
                    case SEARCH_TYPE.po:
                        return { title: `${this.props.translate('Search.Common.Company')}`, bodyHtml: this.props.translate('SearchTips.AML.PO.Body') };
                    case SEARCH_TYPE.bulk:
                        if (!isNullOrUndefined(prefilledData) && prefilledData.aml365)
                            return { title: `${this.props.translate('Search.Common.Bulk')}`, bodyHtml: this.props.translate('SearchTips.AML365.Bulk.Body') };
                        return { title: `${this.props.translate('Search.Common.Bulk')}`, bodyHtml: this.props.translate('SearchTips.AML.Bulk.Body') };
                    case SEARCH_TYPE.fpo:
                        return { title: `${this.props.translate('Search.Aml.ForeignCompany')}`, bodyHtml: this.props.translate('SearchTips.AML.FPO.Body') };
                    default:
                        return false;
                }
            default:
                return false;
        }
    }

    getTabs(registry) {
        let ret = [];
        switch (registry) {
            case REGISTRY.cee:
            case REGISTRY.cre:
            case REGISTRY.rpve:
                ret.push({
                    type: SEARCH_TYPE.fo, icon: <IconFO className="tabs-icon" />, titleKey: 'Search.Common.PhysicalPerson',
                    descriptionKey: 'Search.Common.PhysicalPerson.Description', hr: true
                });
                ret.push({
                    type: SEARCH_TYPE.po, icon: <IconPO className="tabs-icon" />, titleKey: 'Search.Common.Company',
                    descriptionKey: 'Search.Common.Company.Description', hr: true
                });
                if ((registry === REGISTRY.cee && hasPermission(null, "CEEBulk")) || (registry === REGISTRY.cre && hasPermission(null, "CREBulk")) || (registry === REGISTRY.rpve && hasPermission(null, "RPVEBulk")))
                    ret.push(
                        {
                            type: SEARCH_TYPE.bulk, icon: <IconBulk className="tabs-icon" />, titleKey: 'Search.Common.Bulk',
                            descriptionKey: 'Search.Common.Bulk.Description', hr: true
                        });
                ret.push(
                    {
                        type: SEARCH_TYPE.trialFile, icon: <IconCause className="tabs-icon" />, titleKey: 'Search.Common.CauseSearch',
                        descriptionKey: 'Search.Common.CauseSearch.Description', hr: false
                    });
                break;
            case REGISTRY.aml:
                if (hasPermission(null, "PersonAMLInfo"))
                    ret.push(
                        {
                            type: SEARCH_TYPE.fo, icon: <IconFPO className="tabs-icon" />, titleKey: 'Search.Common.PhysicalPerson',
                            descriptionKey: 'Search.Aml.PhysicalPerson.Description', hr: true
                        },
                        {
                            type: SEARCH_TYPE.fpo, icon: <IconPOCZSK className="tabs-icon" />, titleKey: 'Search.Aml.ForeignCompany',
                            descriptionKey: 'Search.Aml.ForeignCompany.Description', hr: true
                        });
                if (hasPermission(null, "CompanyAMLInfo"))
                    ret.push(
                        {
                            type: SEARCH_TYPE.po, icon: <IconBulk className="tabs-icon" />, titleKey: 'Search.Aml.CzSkCompany',
                            descriptionKey: 'Search.Aml.CzSkCompany.Description', hr: true
                        });
                if (hasPermission(null, "AMLbulk"))
                    ret.push(
                        {
                            type: SEARCH_TYPE.bulk, icon: <IconCause className="tabs-icon" />, titleKey: 'Search.Common.Bulk',
                            descriptionKey: 'Search.Aml.Bulk.Description', hr: false
                        });
                break;
            default:
        }
        return ret;
    }

    isSearchEnabled = (values) => {
        switch (this.props.registry) {
            case REGISTRY.cre:
                if (this.state.selected === SEARCH_TYPE.fo) {
                    return ((!isNullOrUndefined(values.birthId) && values.birthId.trim() !== "") ||
                        (!isNullOrUndefined(values.surname) && values.surname.trim() !== "" && !isNullOrUndefined(values.birthDate) && values.birthDate.trim() !== "") ||
                        (!isNullOrUndefined(values.surname) && values.surname.trim() !== "" && !isNullOrUndefined(values.city) && values.city.trim() !== ""));
                } else if (this.state.selected === SEARCH_TYPE.po)
                    return ((!isNullOrUndefined(values.poIco) && values.poIco.trim() !== "") || (!isNullOrUndefined(values.companyName) && values.companyName.trim() !== ""));
                else if (this.state.selected === SEARCH_TYPE.bulk)
                    return (!isNullOrUndefined(values.bulkFile));
                else if (this.state.selected === SEARCH_TYPE.trialFile)
                    return (!isNullOrUndefined(values.trialFileNumber) && values.trialFileNumber.trim() !== "");
                return true;
            case REGISTRY.cee:
                if (this.state.selected === SEARCH_TYPE.fo) {
                    return ((!isNullOrUndefined(values.birthId) && values.birthId.trim() !== "") ||
                        (!isNullOrUndefined(values.fullName) && values.fullName.trim() !== "" && !isNullOrUndefined(values.birthDate) && values.birthDate.trim() !== "") ||
                        (!isNullOrUndefined(values.fullName) && values.fullName.trim() !== "" && !isNullOrUndefined(values.address) && values.address.trim() !== ""));
                } else if (this.state.selected === SEARCH_TYPE.po)
                    return ((!isNullOrUndefined(values.poIco) && values.poIco.trim() !== "") || (!isNullOrUndefined(values.companyName) && values.companyName.trim() !== ""));
                else if (this.state.selected === SEARCH_TYPE.bulk)
                    return (!isNullOrUndefined(values.bulkFile));
                else if (this.state.selected === SEARCH_TYPE.trialFile)
                    return (!isNullOrUndefined(values.trialFileNumber) && values.trialFileNumber.trim() !== "");
                return true;
            case REGISTRY.aml:
                if (this.state.selected === SEARCH_TYPE.fo) {
                    return ((!isNullOrUndefined(values.firstName) && values.firstName.trim() !== "") && (!isNullOrUndefined(values.surname) && values.surname.trim() !== ""));
                } else if (this.state.selected === SEARCH_TYPE.fpo) {
                    return (!isNullOrUndefined(values.businessName) && values.businessName.trim() !== "");
                } else if (this.state.selected === SEARCH_TYPE.po) {
                    return ((!isNullOrUndefined(values.poIco) && values.poIco.trim() !== "") && (!isNullOrUndefined(values.poCountry) && values.poCountry.trim() !== ""));
                } else if (this.state.selected === SEARCH_TYPE.bulk)
                    return (!isNullOrUndefined(values.bulkFile))
                return true;
            default:
                return true
        }
    }

    isSearchRPVEEnabled(values) {
        switch (this.props.registry) {
            case REGISTRY.rpve:
            case REGISTRY.cre:
                if (this.state.selected === SEARCH_TYPE.fo) {
                    return (
                        ((!isNullOrUndefined(values.surname) && values.surname.trim() !== "" &&
                            !isNullOrUndefined(values.firstName) && values.firstName.trim() !== "" &&
                            !isNullOrUndefined(values.birthId) && values.birthId.trim() !== "") ||
                            (!isNullOrUndefined(values.surname) && values.surname.trim() !== "" &&
                                !isNullOrUndefined(values.firstName) && values.firstName.trim() !== "" &&
                                !isNullOrUndefined(values.birthDate) && values.birthDate.trim() !== "")) &&
                        !values.includeMonetary && (isNullOrUndefined(values.city) || values.city.trim() === "")
                    );
                } else if (this.state.selected === SEARCH_TYPE.po)
                    return (!isNullOrUndefined(values.poIco) && values.poIco.trim() !== "" && !values.includeMonetary);
                else if (this.state.selected === SEARCH_TYPE.bulk)
                    return (!isNullOrUndefined(values.bulkFile) && !values.includeMonetary);
                else if (this.state.selected === SEARCH_TYPE.trialFile)
                    return (!isNullOrUndefined(values.trialFileNumber) && values.trialFileNumber.trim() !== "");
                return false;
            default:
                return false;
        }
    }

    getFromCustomerSettings = (key) => {
        const settings = this.props[this.props.registry].settings;
        if (isNullOrUndefined(settings))
            return "";

        const value = settings[`${this.props.registry}${key}`];
        return isNullOrUndefined(value) ? "" : this.props.registry === REGISTRY.cee && key === "CasesNotOlderThan" ? moment(value).format("YYYY-MM-DD") : value;
    }

    onNumberChanged = (fieldName, value, setFieldValue, defaultValue = null, min = null, max = null) => {
        let parsed = parseInt(value);
        if (isNullOrUndefined(parsed) || isNaN(parsed))
            parsed = defaultValue;
        if (!isNullOrUndefined(parsed) && !isNullOrUndefined(min) && !isNaN(min) && parsed < min)
            parsed = min;
        if (!isNullOrUndefined(parsed) && !isNullOrUndefined(max) && !isNaN(max) && parsed > max)
            parsed = max;
        setFieldValue(fieldName, isNullOrUndefined(parsed) ? "" : parsed);
    }
}

export default withLocalize(withRouter(connect(
    state => { return { ...state.registrySearch, user: state.userContext, ls: state.lastSubjects, relationsSearch: state.relationsSearch } },
    dispatch => bindActionCreators({ ...registrySearchActions, ...popupActions, ...windowActions, ...relationsSearchActions }, dispatch)
)(CeeSubjectSearchComponent)));
